/* eslint-disable no-unused-vars */
import * as React from "react";
import {
  Accordion,
  AccordionActions,
  AccordionDetails,
  AccordionSummary,
  Grid,
  TableBody,
  TableHead,
  Typography,
} from "@mui/material";
import { connect, useDispatch, useSelector } from "react-redux";
import SearchReport from "../SearchReport";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import axios from "axios";

import { ExpandMore } from "@mui/icons-material";

import { CLIENTES_REDUX_REPORT } from "../../../redux/constanst";
import fetchCall from "../models/fetch.mjs";
import LoadScreen from "../loadScreen";

import TextField from "@mui/material/TextField";
import { forMiles, hosting, mapStateToProps } from "../models/buscar";
import TarifaEditList from "./parteTarifaEdit/TarifaEditList";
import TarifaMinutoEditList from "./parteTarifaEdit/TarifaMinutoEditList";

function AdmEditarTarifasAcordeon(props) {
  const { clientesReduxReport } = useSelector(
    (state) => state.userState
  );
  const arrSuma = [];
  const [uf, setUf] = React.useState(0);

  const [ufs, setUfS] = React.useState(0);
  const [valor, setValor] = React.useState({});
  const [yearDesde, setYearDesde] = React.useState({
    'mes': new Date().getMonth(),
    'year': new Date().getFullYear()
  });
  const [yearDesdeS, setYearDesdeS] = React.useState({});

  const [sumaTotal, setSumaTotal] = React.useState(0);
  const dispatch = useDispatch();

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    "&:last-child td, &:last-child th": {
      border: 0,
    },
  }));

  const fnSumar = () => {
    var suma = arrSuma.reduce((a, b) => parseFloat(a) + parseFloat(b), 0);
    return suma;
  };

  React.useEffect(() => {
    setSumaTotal(fnSumar());

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [arrSuma]);

  React.useEffect(() => {
    axios
      .get(`${hosting}/mimegacall/api/select_usuarios_empresa.php`)
      .then((response) => {
        const arr = Object.values(response.data);
        dispatch({ type: CLIENTES_REDUX_REPORT, clientesReduxReport: arr });
        setNames(arr);
      })
      .catch(function (error) {
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const anexosAmbos2 = [
    {
      item: 0,
      name: "Editar Tarifas",
    },
  ];
  const [names, setNames] = React.useState(clientesReduxReport);

  const [rows, setRows] = React.useState([]);

  const [open, setOpen] = React.useState(false);
  const [rut, setRut] = React.useState(false);

  const [tarifas, setTarifas] = React.useState(false);

  const [empresa, setEmpresa] = React.useState(false);

  const [empresaS, setEmpresaS] = React.useState(false);
  const mesArray = [
    { name: "Enero", value: 1 },
    { name: "Febrero", value: 2 },
    { name: "Marzo", value: 3 },
    { name: "Abril", value: 4 },
    { name: "Mayo", value: 5 },
    { name: "Junio", value: 6 },
    { name: "Julio", value: 7 },
    { name: "Agosto", value: 8 },
    { name: "Septiembre", value: 9 },
    { name: "Octubre", value: 10 },
    { name: "Noviembre", value: 11 },
    { name: "Diciembre", value: 12 },
  ];

  const yearArray = [
    { name: "2022", value: 2022 },
    { name: "2023", value: 2023 },
    { name: "2024", value: 2043 },
  ];
  const handleChange = async (event) => {
    setOpen(true);
    setValor({});
    const busqueda = clientesReduxReport.filter(
      (data) => data.name === empresa

    );


    setRut(busqueda[0].rut);
    const listaGrupo = busqueda[0].sucursales.map(async (item, index) => {
      const datosResult = await fetchCall(
        "salientes_total",
        0,
        1,
        yearDesde.mes,
        new Date(yearDesde.year, yearDesde.mes, 0).getDate(),
        yearDesde.mes,
        yearDesde.year,
        yearDesde.year,
        item.anexos
      );

      item["cost"] = await datosResult.costoTotal;
      return item;
    });

    axios
      .get(
        `${hosting}/mimegacall/api/select_tarifa_servicios.php?id_user=${busqueda[0].id}`
      )
      .then((response) => {
        setTarifas(response.data);
      });

    Promise.all(listaGrupo).then((res) => {
      setEmpresaS(empresa);
      setYearDesdeS(yearDesde);
      setUfS(uf)
      setRows(res);
      setOpen(false);
    });
  };

  //

  /* const busqueda = async (anexos2, index) => {
    const formData = new FormData();
    formData.append("fechaDesde", yearDesde);
    formData.append("fechaFinal", yearHasta);
    formData.append("anexos", JSON.stringify(anexos2));
    const resp = await fetch(`${hosting}/mimegacall/api/salientes.php`, {
      headers: {
        Accept: "application/json",
      },
      method: "POST",
      body: formData,
    }).then((response) => {
      return response.json();
    }); 

    setValor({...valor, 
        [index]: resp.costoTotal}) 
    return resp;
  }; */
  return (
    <div>
      {anexosAmbos2.map((solicitud) => {
        return (
          <>
            <Typography
              style={{
                marginLeft: 20,
                fontSize: 18,
                alignItems: "left",
                justifyContent: "left",
                textAlign: "left",
                borderRadius: 10,
                padding: 5,
                fontWeight: "600",
              }}
            >
              {solicitud.name}
            </Typography>
            <div
              style={{
                width: "100%",
                flexDirection: "row",
                marginTop: 0,
                alignItems: "flex-start",
                justifyContent: "center",
                paddingTop: 5,
              }}
            >
              {/**ACORDEONES */}

              <Accordion
                style={{
                  flex: 1,
                  width: "99%",
                  margin: "0.5%",
                  background: "rgba(0,0,0,0.2)",
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMore />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    textAlign: "right",
                  }}
                >
                  <Typography
                    style={{
                      marginLeft: 20,
                      fontSize: 14,
                      alignItems: "center",
                      justifyContent: "center",
                      borderRadius: 10,
                      padding: 5,
                      fontWeight: "600",
                    }}
                  >
                    Tarifa por servicio
                  </Typography>
                </AccordionSummary>
                <TarifaEditList/>
              </Accordion>

              <Accordion
                style={{
                  flex: 1,
                  width: "99%",
                  margin: "0.5%",
                  background: "rgba(0,0,0,0.2)",
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMore />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    textAlign: "right",
                  }}
                >
                  <Typography
                    style={{
                      marginLeft: 20,
                      fontSize: 14,
                      alignItems: "center",
                      justifyContent: "center",
                      borderRadius: 10,
                      padding: 5,
                      fontWeight: "600",
                    }}
                  >
                    Tarifa por segundo
                  </Typography>
                </AccordionSummary>
                <TarifaMinutoEditList/>
              </Accordion>
            </div>
          </>
        );
      })}

    </div>
  );
}

export default connect(mapStateToProps, null)(AdmEditarTarifasAcordeon);
